import { message } from 'antd';
import { config } from "util/config";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';
import moment from 'moment';

// JobContact 顶部按钮：打开 Job Detail 右侧抽屉并核验全部 Builder 登记号。
export function builderRegistrationValidation({ pageComponent } = {}) {
  pageComponent.setState({ builderRegistrationValidationShow: true }, () => {
    pageComponent.builderRegistrationValidation.current?.runValidation();
  });
}

// Queensland QBCC 核验复用现有抽屉，但使用独立接口和数据源。
export function builderRegistrationValidationQBCC({ pageComponent } = {}) {
  pageComponent.setState({ builderRegistrationValidationShow: true }, () => {
    pageComponent.builderRegistrationValidation.current?.runValidation('QBCC');
  });
}

//AddFromContact 找自动完成联系人的数据源
export function searchContactChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  parameter = parameter.replace(/#/g, '');
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&moduleId=' + pageComponent.state.moduleId)
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          let all = [];
          data.data.map((contact, j) => {
            let text = (contact.FullNameCompany + (!globalFunction.isNullOrEmpty(contact.RegNum) ? ' (' + contact.RegNum + ')' : '')).trim();
            if (all.indexOf(text) < 0) {
              options.push({ label: text, value: text, data: contact });
              all.push(text);
            }
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//AddFromContact 选择后快速填写数据
export function searchContactSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('FirstName', data.data.FirstName);
  formComponent.formRef.current?.setFieldValue('LastName', data.data.LastName);
  formComponent.formRef.current?.setFieldValue('Company', data.data.Company);
  formComponent.formRef.current?.setFieldValue('JobTitle', data.data.JobTitle);
  formComponent.formRef.current?.setFieldValue('Phone', data.data.Phone);
  formComponent.formRef.current?.setFieldValue('Mobile', data.data.Mobile);
  formComponent.formRef.current?.setFieldValue('Email', data.data.Email);
  formComponent.formRef.current?.setFieldValue('BusinessNo', data.data.BusinessNo);

  formComponent.formRef.current?.setFieldValue('StreetNumber', data.data.StreetNumber);
  formComponent.formRef.current?.setFieldValue('StreetName', data.data.StreetName);
  formComponent.formRef.current?.setFieldValue('Suburb', data.data.Suburb);
  formComponent.formRef.current?.setFieldValue('State', data.data.State);
  formComponent.formRef.current?.setFieldValue('CityTown', data.data.CityTown);
  formComponent.formRef.current?.setFieldValue('Postcode', data.data.Postcode);
  formComponent.formRef.current?.setFieldValue('Country', data.data.Country);

  formComponent.formRef.current?.setFieldValue('PostalStreetNumber', data.data.PostalStreetNumber);
  formComponent.formRef.current?.setFieldValue('PostalStreetName', data.data.PostalStreetName);
  formComponent.formRef.current?.setFieldValue('PostalSuburb', data.data.PostalSuburb);
  formComponent.formRef.current?.setFieldValue('PostalPostcode', data.data.PostalPostcode);
  formComponent.formRef.current?.setFieldValue('PostalState', data.data.PostalState);
  formComponent.formRef.current?.setFieldValue('PostalCityTown', data.data.PostalCityTown);
  formComponent.formRef.current?.setFieldValue('PostalCountry', data.data.PostalCountry);

  formComponent.formRef.current?.setFieldValue('RegNum', data.data.RegNum);
  formComponent.formRef.current?.setFieldValue('CompanyRegNum', data.data.CompanyRegNum);
  formComponent.formRef.current?.setFieldValue('PractitionerClass', data.data.PractitionerClass);
}

let setAutoComplete = false;
//Search Address从google map找自动完成地址的数据源
export function searchAddressChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && setAutoComplete === false) {
    setAutoComplete = true;

    let options = {
      componentRestrictions: {
        country: [pageComponent.state.jobData.Module.Country]
      }
    };

    var input = document.getElementById('JobContactSearchAddress');
    var autocomplete = new window.google.maps.places.Autocomplete(input, options);

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (place.place_id.length > 150) {
        message.warning('The address you selected does not exist. Please select another one.');
      } else {
        console.log(place.address_components);
        for (var i = 0; i < place.address_components.length; i++) {
          switch (pageComponent.state.jobData.Module.Country.toLowerCase()) {
            case 'nz':
              if (place.address_components[i].types[0] == "street_number") {
                formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "route") {
                formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "sublocality_level_1") {
                formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "locality") {
                formComponent.formRef.current?.setFieldValue('CityTown', place.address_components[i].short_name);
              }
              if (place.address_components[i].types[0] == "postal_code") {
                formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "country") {
                formComponent.formRef.current?.setFieldValue('Country', place.address_components[i].long_name);
              }
              break;
            default:
              if (place.address_components[i].types[0] == "street_number") {
                formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "route") {
                formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "locality") {
                formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "administrative_area_level_1") {
                formComponent.formRef.current?.setFieldValue('State', place.address_components[i].short_name);
              }
              if (place.address_components[i].types[0] == "postal_code") {
                formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "country") {
                formComponent.formRef.current?.setFieldValue('Country', place.address_components[i].long_name);
              }
              break;
          }
        }
        formComponent.formRef.current?.setFieldValue('JobContactSearchAddress', place.formatted_address);
      }
    })
  }
}

//选Same As Property Address时给Address赋值当前job的Property的值
export function setSameAsPropertyAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    formComponent.formRef.current?.setFieldValue('StreetNumber', pageComponent.state.jobData.PptStreetNumber);
    formComponent.formRef.current?.setFieldValue('StreetName', pageComponent.state.jobData.PptStreetName);
    formComponent.formRef.current?.setFieldValue('Suburb', pageComponent.state.jobData.PptSuburb);
    formComponent.formRef.current?.setFieldValue('State', pageComponent.state.jobData.PptState);
    formComponent.formRef.current?.setFieldValue('CityTown', pageComponent.state.jobData.PptCityTown);
    formComponent.formRef.current?.setFieldValue('Postcode', pageComponent.state.jobData.PptPostcode);
  } else {
    formComponent.formRef.current?.setFieldValue('StreetNumber', '');
    formComponent.formRef.current?.setFieldValue('StreetName', '');
    formComponent.formRef.current?.setFieldValue('Suburb', '');
    formComponent.formRef.current?.setFieldValue('State', '');
    formComponent.formRef.current?.setFieldValue('CityTown', '');
    formComponent.formRef.current?.setFieldValue('Postcode', '');
  }
}

//选Same As Contact Address时给Postal Address赋值
export function setSameAsContactAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', formComponent.formRef.current?.getFieldValue('StreetNumber'));
    formComponent.formRef.current?.setFieldValue('PostalStreetName', formComponent.formRef.current?.getFieldValue('StreetName'));
    formComponent.formRef.current?.setFieldValue('PostalSuburb', formComponent.formRef.current?.getFieldValue('Suburb'));
    formComponent.formRef.current?.setFieldValue('PostalState', formComponent.formRef.current?.getFieldValue('State'));
    formComponent.formRef.current?.setFieldValue('PostalCityTown', formComponent.formRef.current?.getFieldValue('CityTown'));
    formComponent.formRef.current?.setFieldValue('PostalPostcode', formComponent.formRef.current?.getFieldValue('Postcode'));
    formComponent.formRef.current?.setFieldValue('PostalCountry', formComponent.formRef.current?.getFieldValue('Country'));
  } else {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', '');
    formComponent.formRef.current?.setFieldValue('PostalStreetName', '');
    formComponent.formRef.current?.setFieldValue('PostalSuburb', '');
    formComponent.formRef.current?.setFieldValue('PostalState', '');
    formComponent.formRef.current?.setFieldValue('PostalCityTown', '');
    formComponent.formRef.current?.setFieldValue('PostalPostcode', '');
    formComponent.formRef.current?.setFieldValue('PostalCountry', '');
  }
}

//CopyFrom 快速填写数据
export function copyFromJobContact({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter > 0) {
    httpClient
      .get('/Business/JobContact/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          formComponent.formRef.current?.setFieldValue('FirstName', data.data.FirstName);
          formComponent.formRef.current?.setFieldValue('LastName', data.data.LastName);
          formComponent.formRef.current?.setFieldValue('Company', data.data.Company);
          formComponent.formRef.current?.setFieldValue('JobTitle', data.data.JobTitle);
          formComponent.formRef.current?.setFieldValue('Phone', data.data.Phone);
          formComponent.formRef.current?.setFieldValue('Mobile', data.data.Mobile);
          formComponent.formRef.current?.setFieldValue('Email', data.data.Email);
          formComponent.formRef.current?.setFieldValue('BusinessNo', data.data.BusinessNo);
          formComponent.formRef.current?.setFieldValue('BuilderSubsection24b', data.data.BuilderSubsection24b);

          formComponent.formRef.current?.setFieldValue('StreetNumber', data.data.StreetNumber);
          formComponent.formRef.current?.setFieldValue('StreetName', data.data.StreetName);
          formComponent.formRef.current?.setFieldValue('Suburb', data.data.Suburb);
          formComponent.formRef.current?.setFieldValue('State', data.data.State);
          formComponent.formRef.current?.setFieldValue('CityTown', data.data.CityTown);
          formComponent.formRef.current?.setFieldValue('Postcode', data.data.Postcode);
          formComponent.formRef.current?.setFieldValue('Country', data.data.Country);

          formComponent.formRef.current?.setFieldValue('PostalStreetNumber', data.data.PostalStreetNumber);
          formComponent.formRef.current?.setFieldValue('PostalStreetName', data.data.PostalStreetName);
          formComponent.formRef.current?.setFieldValue('PostalSuburb', data.data.PostalSuburb);
          formComponent.formRef.current?.setFieldValue('PostalPostcode', data.data.PostalPostcode);
          formComponent.formRef.current?.setFieldValue('PostalState', data.data.PostalState);
          formComponent.formRef.current?.setFieldValue('PostalCityTown', data.data.PostalCityTown);
          formComponent.formRef.current?.setFieldValue('PostalCountry', data.data.PostalCountry);

          formComponent.formRef.current?.setFieldValue('RegNum', data.data.RegNum);
          formComponent.formRef.current?.setFieldValue('CompanyRegNum', data.data.CompanyRegNum);
          formComponent.formRef.current?.setFieldValue('PractitionerType', data.data.PractitionerType !== null ? data.data.PractitionerType : -1);
          formComponent.formRef.current?.setFieldValue('PractitionerClass', data.data.PractitionerClass);
          formComponent.formRef.current?.setFieldValue('NominatedLevyPayer', data.data.NominatedLevyPayer);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function customFormOnSubmit({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let areaName = sectionComponent.props.areaName;
  let pageName = sectionComponent.props.pageName;
  let form = formComponent.formRef.current?.getFieldsValue();
  form.jobId = pageComponent.props.jobId;
  switch (sectionComponent.state.componentType) {
    case 'Create':
      httpClient
        .post(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            formComponent.resetFields();
            sectionComponent.setState({ showModal: false });
            sectionComponent.getSectionDataByDefault();
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
      break;
    case 'Edit':
      form.key = sectionComponent.customForm.current?.state.currentDataKey;
      httpClient
        .put(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            if (sectionComponent.state.closeModelAfterSubmit !== false) {
              sectionComponent.setState({ showModal: false });
            }
            sectionComponent.getSectionDataByDefault();
          } else {
            if (data.code === 2) {
              message.error(data.message);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
      break;
  }
}

export function addSubmitFinish({ sectionName, formComponent, sectionComponent, pageComponent }) {
  let parameter = [{ key: 'jobId', value: pageComponent.props.jobId }];
  let uie;
  sectionComponent.props.section.componentList.filter(c => c.type === 'Create')[0].groupList.forEach(group => {
    group.uieList.forEach(u => {
      if (u.source === 'CopyFrom') {
        uie = u;
      }
    });
  });

  let parameterStr = '';
  parameter.forEach(item => {
    parameterStr += item.key + '=' + item.value + '&';
  })
  httpClient
    .get(uie.datasourceUrl + '?' + parameterStr)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let componentDataSource = { ...formComponent.state.componentDataSource };
          if (uie.required) {
            dataSource = dataSource.filter(item => item.Value !== 0);
          }
          componentDataSource[uie.source] = dataSource;
          formComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getPreviousJobContact({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('SameAsPropertyAddress', false);
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('SameAsContactAddress', false);
  let jobContactIdIds = [];
  sectionComponent.child.current?.state.data.map(folder => {
    jobContactIdIds.push(folder.JobContactId);
  });

  let index = jobContactIdIds.indexOf(parameter) - 1;
  if (index >= 0 && index <= jobContactIdIds.length - 1) {
    let id = jobContactIdIds[index];
    editJobContact({ parameter: { key: id }, sectionComponent, pageComponent, sectionName, uie });
  }

}

export function getNextJobContact({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('SameAsPropertyAddress', false);
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('SameAsContactAddress', false);
  let jobContactIdIds = [];
  sectionComponent.child.current?.state.data.map(folder => {
    jobContactIdIds.push(folder.JobContactId);
  });

  let index = jobContactIdIds.indexOf(parameter) + 1;
  if (index >= 0 && index <= jobContactIdIds.length - 1) {
    let id = jobContactIdIds[index];
    editJobContact({ parameter: { key: id }, sectionComponent, pageComponent, sectionName, uie });
  }
}

export function showCompanyContact({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  pageComponent.setState({ jobContact: parameter, companyContactShow: true });
  setTimeout(() => {
    pageComponent.companyContact.current?.getCompanyContactData();
  }, config.setTimeoutMilliSecond);
}



export function editJobContact({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {

  let jobContactIdIds = [];
  sectionComponent.child.current?.state.data.map(folder => {
    jobContactIdIds.push(folder.JobContactId);
  });
  let index = jobContactIdIds.indexOf(parameter.key);
  if (index === 0) {
    sectionComponent.setState({ showModal: true, componentType: 'Edit', previousButtonDisabled: true });
  } else {
    sectionComponent.setState({ showModal: true, componentType: 'Edit', previousButtonDisabled: false });
  }
  if (index === jobContactIdIds.length - 1) {
    sectionComponent.setState({ showModal: true, componentType: 'Edit', nextButtonDisabled: true });
  } else {
    sectionComponent.setState({ showModal: true, componentType: 'Edit', nextButtonDisabled: false });
  }

  // sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
        sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
          group.uieList.forEach(uie => {
            switch (uie.component) {
              case 'DatePicker':
                //处理日期, 把字符串转成moment
                if (data.data[uie.source] !== null && data.data[uie.source] !== undefined) {
                  data.data[uie.source] = moment(data.data[uie.source], config.format.date);
                } else {
                  data.data[uie.source] = undefined;
                }
                break;
            }
          });
        });
        setTimeout(() => {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });
          sectionComponent.setState({ isFormModified: false });
        }, config.setTimeoutMilliSecond * 2);
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getBuilderSubsection24bDataSourceRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  if (componentDataSource['AllBuilderSubsection24b'] === undefined) {
    componentDataSource['AllBuilderSubsection24b'] = componentDataSource['BuilderSubsection24b'];
  } else {
    componentDataSource['BuilderSubsection24b'] = componentDataSource['AllBuilderSubsection24b'];
  }
  sectionComponent.customForm.current?.setState({ componentDataSource });
}

export function builderSubsection24bChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  componentDataSource['BuilderSubsection24b'] = parameter
    ? sectionComponent.customForm.current?.state.componentDataSource['AllBuilderSubsection24b'].filter((item) => item.label.toLowerCase().indexOf(parameter.toLowerCase()) >= 0)
    : sectionComponent.customForm.current?.state.componentDataSource['AllBuilderSubsection24b'];
  sectionComponent.customForm.current?.setState({ componentDataSource });
}

export function addJobContactPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let copyFrom = [{ Key: "- Select Job Contact -", Value: 0 }];
  sectionComponent.child.current?.state.data.map(data => {
    copyFrom.push({ Key: data.ContactTypeName + ' - ' + data.FullNameCompany, Value: data.JobContactId });
  });
  sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ State: pageComponent.state.jobData.ModuleConfig.DefaultState, PostalState: pageComponent.state.jobData.ModuleConfig.DefaultState, Country: pageComponent.state.jobData.ModuleConfig.DefaultCountry, PostalCountry: pageComponent.state.jobData.ModuleConfig.DefaultCountry });
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  componentDataSource['BuilderSubsection24b'] = componentDataSource['AllBuilderSubsection24b'];
  componentDataSource['CopyFrom'] = copyFrom;
  sectionComponent.customForm.current?.setState({ componentDataSource });
  setAutoComplete = false;
}

export function editJobContactPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  componentDataSource['BuilderSubsection24b'] = componentDataSource['AllBuilderSubsection24b'];
  sectionComponent.customForm.current?.setState({ componentDataSource });
  setAutoComplete = false;
}
